import { render, staticRenderFns } from "./Thistorytable.vue?vue&type=template&id=4440d986"
import script from "./Thistorytable.vue?vue&type=script&lang=js"
export * from "./Thistorytable.vue?vue&type=script&lang=js"
import style0 from "./Thistorytable.vue?vue&type=style&index=0&id=4440d986&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports